import { forwardRef } from 'react';
import { currencyFormat } from '../../Utils/formatCurrency';
import { dateFormat } from '../../Utils/formatDate';

const getTotal = (total, key) => Number(total?.[key]?.total || 0);

const FormatPrintDailyReport = forwardRef((props, ref) => {
  const { data = [], total = null } = props;

  const totalTunai = getTotal(total, 'total_tunai');
  const totalEdcBca = getTotal(total, 'total_edc_bca');
  const totalEdcBri = getTotal(total, 'total_edc_bri');
  const totalEdcMandiri = getTotal(total, 'total_edc_mandiri');
  const totalEdcKredivo = getTotal(total, 'total_edc_kredivo');
  const totalVoucher = getTotal(total, 'total_voucher');

  const totalPendapatan =
    totalTunai + totalEdcBca + totalEdcBri + totalEdcMandiri + totalEdcKredivo;

  const totalTransaksi = data.reduce(
    (sum, outlet) => sum + Number(outlet.transactions?.length || 0),
    0
  );

  return (
    <div ref={ref} style={{ margin: 10 }}>
      <h2 style={{ textAlign: 'center' }}>Laporan Harian Per Outlet</h2>

      <table className="tbl_border" style={{ width: '100%', marginBottom: 20 }}>
        <tbody>
          <tr>
            <td className="tbl_border"><b>Total Transaksi</b></td>
            <td className="tbl_border">{totalTransaksi} Transaksi</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total Tunai</b></td>
            <td className="tbl_border">{currencyFormat(totalTunai)}</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total EDC BCA</b></td>
            <td className="tbl_border">{currencyFormat(totalEdcBca)}</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total EDC BRI</b></td>
            <td className="tbl_border">{currencyFormat(totalEdcBri)}</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total EDC Mandiri</b></td>
            <td className="tbl_border">{currencyFormat(totalEdcMandiri)}</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total EDC Kredivo</b></td>
            <td className="tbl_border">{currencyFormat(totalEdcKredivo)}</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total Voucher</b></td>
            <td className="tbl_border">{currencyFormat(totalVoucher)}</td>
          </tr>
          <tr>
            <td className="tbl_border"><b>Total Pendapatan</b></td>
            <td className="tbl_border"><b>{currencyFormat(totalPendapatan)}</b></td>
          </tr>
        </tbody>
      </table>

      <table className="tbl_border" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th className="tbl_border"><b>No.</b></th>
            <th className="tbl_border"><b>Tanggal</b></th>
            <th className="tbl_border"><b>Nama Outlet</b></th>
            <th className="tbl_border"><b>Status Outlet</b></th>
            <th className="tbl_border"><b>Total Transaksi</b></th>
            <th className="tbl_border"><b>Total Pendapatan</b></th>
          </tr>
        </thead>

        <tbody>
          {data.map((key, i) => {
            const outletTotal = key.transactions?.reduce(
              (sum, item) => sum + Number(item.grand_total || 0),
              0
            ) || 0;

            return (
              <tr key={i}>
                <td className="tbl_border">{i + 1}</td>
                <td className="tbl_border">
                  {key.transactions?.length > 0
                    ? dateFormat(key.transactions[0].created_at)
                    : '-'}
                </td>
                <td className="tbl_border">{key.outlet_name}</td>
                <td className="tbl_border">
                  {key.isClosed === true ? 'Tutup' : 'Buka'}
                </td>
                <td className="tbl_border">
                  {key.transactions?.length || 0} Transaksi
                </td>
                <td className="tbl_border">{currencyFormat(outletTotal)}</td>
              </tr>
            );
          })}

          <tr>
            <td className="tbl_border" colSpan={4} style={{ textAlign: 'right' }}>
              <b>GRAND TOTAL</b>
            </td>
            <td className="tbl_border">
              <b>{totalTransaksi} Transaksi</b>
            </td>
            <td className="tbl_border">
              <b>{currencyFormat(totalPendapatan)}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default FormatPrintDailyReport;